import { Group, MantineTheme } from "@mantine/core";
import { IconSquareCheckFilled, IconSquareXFilled, ReactNode } from "@tabler/icons-react";

export function PersonalRecibosViewColumnsOverrides(theme: MantineTheme) {
    return {
        2: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === 'NO') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareXFilled style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                } else if (val === 'SI') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareCheckFilled style={{ color: theme.colors.green[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                }
                return value as ReactNode;
            }
        },
    }
}